import io from 'socket.io-client';
import config from 'config';

// window.io = io(config.esocket.baseUrl);
const socket = io(config.esocket.baseUrl);

export default socket;



/** WEBPACK FOOTER **
 ** ./src/app/helpers/esocket.js
 **/